import { shallowEqual, useDispatch } from "react-redux";
import { defaultImageLoad } from "../../utils/imageFallback";
import { ActionUi, useAppSelector, VRIAppStateType} from "../../core";

export function useFunctionalityImageView() {
  const dispatch = useDispatch();
  const imageView = useAppSelector(
    (state: VRIAppStateType) => ({
      fileTimeStamp:state.ui.fileTimeStamp
    }),
    shallowEqual
  );
  const onUploadComplete = () => {
    dispatch(ActionUi.SetFileTimeStamp(Date.now()));
  };
  return{
    onUploadComplete,
      imageView,
      defaultImageLoad
  }
}
